import { render, staticRenderFns } from "./RoleBasedAccessControlDashboardList.vue?vue&type=template&id=5d07427a"
import script from "./RoleBasedAccessControlDashboardList.vue?vue&type=script&lang=js"
export * from "./RoleBasedAccessControlDashboardList.vue?vue&type=script&lang=js"
import style0 from "./RoleBasedAccessControlDashboardList.vue?vue&type=style&index=0&id=5d07427a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports